import { formatNumber } from 'libphonenumber-js'
import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { confirmPhoneNumber, getUserInfo } from '../actions/AuthAction'
import { getPhaseInformation } from '../actions/FlowAction'
import * as routeService from '../services/routeService'
import * as translationService from '../services/translationService'
import { resendVerificationSms } from '../actions/AuthAction'
import { Button, ErrorText, Form, PinCodeField, Stack } from './../components'
import AuthContent from './AuthContent'
import styles2 from 'assets/scss/views/Auth2.scss'

const COUNT_LIMIT = 60

class VerificationView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      counter: COUNT_LIMIT,
    }
    this.timer = null
  }

  static propTypes = {
    confirmPhoneNumber: PropTypes.func,
    getPhaseInformation: PropTypes.func,
    error: PropTypes.any,
    mobileNumber: PropTypes.string,
    userId: PropTypes.any,
    match: PropTypes.any,
    phaseInformationError: PropTypes.any,
    applicationProfileError: PropTypes.any,
    unverifiedPhone: PropTypes.any,
    unverifiedEmail: PropTypes.string,
    location: PropTypes.any,
    property: PropTypes.any,
    getUserInfo: PropTypes.func,
    token: PropTypes.string,
    resendVerificationSms: PropTypes.func,
  }

  componentDidMount() {
    if (!this.props.mobileNumber && !this.props.unverifiedPhone) {
      // routeService.goToLoginPage()
    }

    this.startCountdown()
  }

  startCountdown = () => {
    this.timer = setInterval(() => {
      this.setState(prevState => {
        if (prevState.counter > 0) {
          return { counter: prevState.counter - 1 }
        } else {
          clearInterval(this.timer)
          return null
        }
      })
    }, 1000)
  }

  resetCountdown = () => {
    this.setState({ counter: COUNT_LIMIT }, () => this.startCountdown())
  }

  handleResendSms = () => {
    const { resendVerificationSms, unverifiedPhone } = this.props
    this.resetCountdown()
    resendVerificationSms(unverifiedPhone)
  }

  onValueChange = event => {
    const { id, value } = event.target
    this.setState(
      {
        [id]: value,
      },
      () => {
        if (value.length === 4) {
          this.confirmPhoneNumber(event)
        }
      },
    )
  }

  backToLogin = () => {
    routeService.goToLoginPage()
  }

  confirmPhoneNumber = async event => {
    const {
      location: { state },
    } = this.props

    if (event.preventDefault) {
      event.preventDefault()
    }
    // confirm the users phone number
    try {
      await this.props.confirmPhoneNumber(this.props.userId, this.state.pincode)
      if (this.props.unverifiedEmail) {
        routeService.goToEmailVerificationPage()
        return
      }
      // Go to register page..
      if (state && state.from) {
        routeService.goToPage(state.from)
      } else {
        routeService.goToRegisterPage({ replace: false })
      }
    } catch (e) {
      this.setState({ error: e })
    }
  }

  render() {
    const { phaseInformationError, applicationProfileError } = this.props
    const { pincoce = '', error } = this.state

    const phone = this.props.unverifiedPhone || this.props.mobileNumber
    const showCounter = this.state.counter > 0

    return (
      <AuthContent title={translationService.VerificationTitle()} hasToken={false}>
        <p>
          {translationService.VerificationMessage()}{' '}
          <strong>
            <strong>{formatNumber(phone || '', 'International')}</strong>
          </strong>
        </p>
        <Form onSubmit={this.confirmPhoneNumber}>
          {(phaseInformationError || applicationProfileError) && (
            <ErrorText>{translationService.generalError()}</ErrorText>
          )}
          <PinCodeField
            id="pincode"
            max={4}
            error={error && translationService.verificationWrongPincode()}
            value={pincoce}
            onChange={this.onValueChange}
            label={translationService.verificationPincodeLabel()}
          />
          <div>
            <Button primary onClick={this.confirmPhoneNumber}>
              {translationService.buttonNext()}
            </Button>
          </div>

          <div>
            <Button plain onClick={this.backToLogin}>
              {translationService.authToLogin()}
            </Button>
          </div>
          <div>
            <div>
              <p>{translationService.noSmsContactSupport()}</p>
            </div>
            <div>
              <div className={styles2.Spacer8} />
              <Stack spacing="tight">
                <p>{translationService.verifySmsNotRecievedMessage()}</p>
                <Button plain={true} onClick={this.handleResendSms} disabled={showCounter}>
                  {translationService.verifySmsResend()}
                  {showCounter && ` (${this.state.counter})`}
                </Button>
              </Stack>
            </div>
          </div>
        </Form>
      </AuthContent>
    )
  }
}

const mapStateToProps = ({ AuthReducer, FlowReducer }) => {
  const { user = {}, error } = AuthReducer
  const { phaseInformationError, applicationProfileError, property } = FlowReducer
  const { mobileNumber, id, unverifiedPhone, unverifiedEmail, token } = user
  return {
    mobileNumber,
    unverifiedPhone,
    unverifiedEmail,
    userId: id,
    property,
    error,
    phaseInformationError,
    applicationProfileError,
    token,
  }
}
const mapDispatchToProps = dispatch => ({
  confirmPhoneNumber: (id, pincode) => dispatch(confirmPhoneNumber(id, pincode)),
  getPhaseInformation: params => dispatch(getPhaseInformation(params)),
  getUserInfo: (userId, token) => dispatch(getUserInfo(userId, token)),
  resendVerificationSms: phone => dispatch(resendVerificationSms(phone)),
})

export default compose(
  translate('translations'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(VerificationView)



// WEBPACK FOOTER //
// ./src/views/VerificationView.js